import { joinMotibell } from "lib/api/motibell/joinMotibell"
import { useMutation } from "@tanstack/react-query"

const useJoinMotibellMutate = () => {
	return useMutation((payload) => joinMotibell(payload))
}

export default useJoinMotibellMutate
